"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var combineReducers = function combineReducers(reducers) {
  var combinedReducers = {};

  var _loop = function _loop(nodeName) {
    if (!reducers.hasOwnProperty(nodeName)) return "continue";
    var initialState = 'initialState' in reducers[nodeName] ? reducers[nodeName].initialState : {};
    var nodeReducers = {};

    for (var methodName in reducers[nodeName]) {
      if (!reducers[nodeName].hasOwnProperty(methodName)) continue;
      if (methodName === 'default') continue;
      if (methodName === 'initialState') continue;
      var reducer = reducers[nodeName][methodName];
      var type = nodeName + "." + methodName;
      nodeReducers[type] = reducer;
    }

    combinedReducers[nodeName] = function (state, _ref) {
      if (state === void 0) {
        state = initialState;
      }

      var type = _ref.type,
          payload = _ref.payload;

      if (type in nodeReducers) {
        return nodeReducers[type](state, payload);
      }

      return state;
    };
  };

  for (var nodeName in reducers) {
    var _ret = _loop(nodeName);

    if (_ret === "continue") continue;
  }

  return combinedReducers;
};

var _default = combineReducers;
exports["default"] = _default;